<template>
  <div>
    <va-modal
      class="evollu-form"
      :value="showModal"
      id="createBiosignalsBlockModal"
      ref="createBiosignalsBlockModal"
      size="large"
      :showOkay="true"
      :okText="this.$t('iframe.titles.create_block')"
      :cancelText="$t('leads.back')"
      @cancel="$emit('cancel')"
      @ok="handleSubmit"
      :ok-disabled="!canSubmit"
      :noOutsideDismiss="true">

      <div slot="header" class="d-flex justify--space-between">
        <span>
          <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ this.$t('iframe.titles.create_block')}}</b></span>
        </span>
      </div>

      <BlockDetails
        v-model="blockForm"
        :form-errors="blockErrors"
        :clientOptions="clientOptions"
      />
    </va-modal>
  </div>
</template>

<script>
import BlockDetails from "@/components/iframe/blocks-builder/biosignals/BlockDetails";
import Errors from "@/utils/StandardErrors";
import {IframeService} from "@/api/IframeService";

const errorsPrefix = 'iframe.blocks_builder.biosignals_block.errors.'

export default {
  components: {BlockDetails},
  data() {
    return {
      isSubmiting: false,
      showModal: false,
      blockForm:{
        name: null,
        lang: null,
        title: '',
        subtitle: '',
        should_show_questionnaire: true,
        show_results_after_test: true
      },
      blockErrors: new Errors()
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    handleSubmit: function() {
      if(this.canSubmit) {
        this.isSubmiting = true
        let data = {...this.blockForm}
        if(this.blockForm.lang !== null) {
          data.lang = this.blockForm.lang.lang
        }
        if(this.blockForm.client) {
          data.client_id = this.blockForm.client.id
        }
        if(this.blockForm.results_page_viewtype) {
          data.results_page_viewtype = this.blockForm.results_page_viewtype.value
        } else {
          data.results_page_viewtype = "complete" //default
        }
        IframeService.createBiosignsPage(data)
        .then(res => {
          this.showToast(this.$t('iframe.blocks_builder.created'), this.$store.state.successToastOptions)
          this.$emit('created' )
          this.showModal = false
        })
        .catch(errors => {
          console.log(errors)
          if(errors.response.status === 422) {
            this.blockErrors.record(errors.response.data.errors, errorsPrefix)
            this.showToast(this.$t('iframe.blocks_builder.create_error'), this.$store.state.errorToastOptions)
          }else {
            this.showToast(this.$t('iframe.blocks_builder.create_error'), this.$store.state.errorToastOptions)
          }
        })
        .finally(() => {
          this.isSubmiting = false
        })
      }
    }
  },
  computed: {
    canSubmit() {
      return (this.blockForm.name !== null && this.blockForm.name !== '') && !this.isSubmiting && this.blockForm.client !== null && this.blockForm.title !== ''
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          if(this.iframeService.entities.length === 1) {
            this.blockForm.client = this.iframeService.entities[0]
          }
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        const consideredEntities = this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
        if (consideredEntities.length === 1) {
          this.blockForm.client = consideredEntities[0]
        }
        return consideredEntities
      }
      return []
    },
  }

}
</script>

<style scoped>

</style>
